export default {
    'name': 'checkmark',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M21.9688 6.33974C22.3593 5.94921 22.3593 5.31605 21.9688 4.92552C21.5783 4.535 20.9451 4.535 20.5546 4.92552L8.52702 16.9531L3.44563 11.8717C3.05511 11.4812 2.42194 11.4812 2.03142 11.8717C1.64089 12.2622 1.64089 12.8954 2.03142 13.2859L7.81992 19.0744C8.21044 19.465 8.84361 19.465 9.23413 19.0744L21.9688 6.33974Z\' fill=\'#026958\'/>'
}
